<template>
  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main clss="index-main">
        <router-view></router-view>
      </el-main>
      <el-footer style="height: 40px;background-color: #334157;">
        <p style="background:none;position: fixed;bottom: -10px;width: 80%;text-align: center;">
          <a style="color:rgb(255, 255, 255);" href="https://beian.miit.gov.cn/#/Integrated/index"
             target="_blank">豫ICP备2022011514号</a>
        </p>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import navcon from "./navcon.vue";
import leftnav from "./leftnav.vue";
export default {
  name: "Index",
  data() {
    return {
      showclass: "asideshow",
      showtype: false,
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (val.path === "/") {
          this.$store.dispatch("getUserInfo");
        }
      },
      immediate: true,
    },
  },
  components: {
    navcon,
    leftnav,
  },
  created() {
    this.$root.Bus.$on("toggle", (value) => {
      if (value) {
        this.showclass = "asideshow";
      } else {
        setTimeout(() => {
          this.showclass = "aside";
        }, 300);
      }
    });
  },
};
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue